import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auth
export const adminLogin = (pin) => api.post("/auth/login", { pin }).then((r) => r.data);
export const adminVerify = () => api.get("/auth/verify").then((r) => r.data);

// Public
export const getServices = () => api.get("/piercing/services").then((r) => r.data);
export const getSettings = () => api.get("/piercing/settings").then((r) => r.data);
export const getAvailability = (dateStr) =>
  api.get("/piercing/availability", { params: { date_str: dateStr } }).then((r) => r.data);
export const createBooking = (data) => api.post("/piercing/bookings", data).then((r) => r.data);
export const getProducts = () => api.get("/piercing/products").then((r) => r.data);

// Admin
export const updateSettings = (data) => api.put("/piercing/settings", data).then((r) => r.data);
export const listBookings = (dateStr) =>
  api.get("/piercing/bookings", { params: dateStr ? { date_str: dateStr } : {} }).then((r) => r.data);
export const updateBookingStatus = (id, status) =>
  api.patch(`/piercing/bookings/${id}/status`, { status }).then((r) => r.data);
export const getProductsAdmin = () => api.get("/piercing/products/admin").then((r) => r.data);
export const createProduct = (data) => api.post("/piercing/products", data).then((r) => r.data);
export const updateProduct = (id, data) => api.put(`/piercing/products/${id}`, data).then((r) => r.data);
export const deleteProduct = (id) => api.delete(`/piercing/products/${id}`).then((r) => r.data);
